function e(e, n) {
  return e.securedFields[n]?.iframeContentWindow || null;
}
export { e as default };
